import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const DEFAULTS = {
  tagline: "The logistics OS for ambitious local commerce.",
  contact_email: "hello@deliveryboss.io",
  contact_address: "Manila · Singapore",
  copyright_text: `© ${new Date().getFullYear()} DeliveryBoss Logistics, Inc.`,
  version_label: "v1.0.0",
  privacy_policy: "# Privacy Policy\n\nLoading…",
  terms_of_service: "# Terms of Service\n\nLoading…",
};

let cache = null;
let pending = null;

/**
 * Fetch site settings once and cache them in-memory for the SPA lifetime.
 * Pages that need fresh values after an admin edit can call `refresh()`.
 */
export function useSiteSettings() {
  const [data, setData] = useState(cache || DEFAULTS);
  const [loading, setLoading] = useState(!cache);

  useEffect(() => {
    if (cache) return;
    if (!pending) {
      pending = api
        .get("/public/site-settings")
        .then((r) => {
          cache = r.data;
          return r.data;
        })
        .catch(() => DEFAULTS)
        .finally(() => {
          pending = null;
        });
    }
    pending.then((d) => {
      setData(d);
      setLoading(false);
    });
  }, []);

  return { data, loading };
}

export function clearSiteSettingsCache() {
  cache = null;
}
